//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TransitionExpand from "./global/TransitionExpand";
export default {
  components: {
    appTransitionExpand: TransitionExpand,
  },
  data: function () {
    return {
      loaded: false,
      mobileOpen: false,
      filterState: [],
      groupState: [],
      selected: [],
    };
  },
  watch: {
    filters() {
      let filterState = [];
      this.filters.forEach((filterGroup) => {
        filterState.push(true);
      });
      this.filterState = filterState;

      if (!this.loaded && this.$route.query.c && this.filters.length > 0) {
        var f = JSON.parse(JSON.stringify(this.filters));
        this.updateFiltersFromQuerystring(this.$route.query.c, f);

        this.$emit("submitFilters", f);
        this.loaded = true;
      }

      this.closeGroups();
    },
  },
  computed: {
    filters: function () {
      return this.$store.state.results.filters;
    },
    settings: function () {
      return this.$store.state.settings;
    },
    visibleFilters: function () {
      return this.filters.filter((f) => f.visible == true);
    },
    selectedFilters: function () {
      var output = [];
      this.$store.state.searchQuery.filters.forEach(function (e) {
        output = output.concat(
          e.filters.filter(function (c) {
            return c.selected == true;
          })
        );
      });

      return output;
    },
  },
  methods: {
    toggleFilter(e, i) {
      const filterState = [...this.filterState];
      filterState[i] = !filterState[i];
      this.filterState = filterState;
    },
    submitFilters: function () {
      this.$emit("submitFilters", this.filters);
    },
    updateFiltersFromQuerystring(query, filters) {
      var ids = query.split(",");

      ids.forEach(function (theID) {
        filters.forEach(function (parent) {
          var match = parent.filters.find((c) => c.id === theID);

          if (match) {
            match.selected = true;
          }
        });
      });
    },
    getFilterText: function (filter) {
      return filter.value + " (" + filter.count + ")";
    },
    closeGroups() {
      let gs = [];
      this.visibleFilters.forEach((group) => {
        gs.push(false);
      });
      this.groupState = gs;
    },
    async toggleGroupOnFocusOut(e, index) {
      await new Promise(resolve => setTimeout(resolve, 100));
      if (document.body.classList.contains('using-mouse')) return;
      if (!this.$refs.tagGroup[index].matches(':focus-within')) {
        this.toggleGroup(null, -1)
      }
    },
    toggleGroup(e, index) {
      let groupState = [...this.groupState];
      groupState = groupState.map((state, i) => {
        if (i === index) {
          state = !state;
        } else {
          state = false;
        }
        return state;
      });
      this.groupState = groupState;
    },
    removeTag(e, option) {
      this.visibleFilters.forEach(function (e) {
        e.filters.forEach(function (f) {
          if (f.id == option.id) {
            f.selected = false;
          }
        });
      });
      this.submitFilters();
    },
  },
  created() {
    var query = this.$route.query.c;
    var ids = query ? query.split(",") : [];
    var changed = false;
    this.filters.forEach((group) => {
      group.filters.forEach((filter) => {
        if (ids.includes(filter.id) && !filter.selected) {
          filter.selected = true;
          changed = true;
        }
      });
    });
    if (changed) {
      this.submitFilters();
    }
  },
  mounted() {
    this.closeGroups();
  },
};
